module.exports = __webpack_public_path__ + "img/witure.6bd9583b.svg";